
import { ref } from 'vue'

export const useDetectDevice = () => {
  const isMobile = ref(false)
  const isDesktop = ref(false)

  const detectDevice = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera

    const isTouch = matchMedia('(pointer: coarse)').matches
    const isSmallScreen = matchMedia('(max-width: 768px)').matches

    const isMobileUA = /android|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua)
    const isTabletUA = /ipad|tablet/i.test(ua)

    const mobile = (isTouch && isSmallScreen) || isMobileUA
    const desktop = !mobile && !isTabletUA

    isMobile.value = mobile
    isDesktop.value = desktop
  }

  detectDevice()

  return { isMobile, isDesktop }
}
